var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h3', [_vm._v("弹出框")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('div', {
      staticClass: "bs-example"
    }, [_c('blockquote', [_c('p', [_vm._v("组件调用")])]), _vm._v(" "), _c('p', [_c('n3-button', {
      nativeOn: {
        "click": function($event) {
          _vm.showModal($event)
        }
      }
    }, [_vm._v("Show modal")]), _vm._v(" "), _c('n3-modal', {
      ref: "modal",
      attrs: {
        "title": "Modal title",
        "effect": "fade",
        "width": "400px"
      }
    })], 1), _vm._v(" "), _c('div', {
      slot: "body"
    }, [_vm._v("\n    What's in a name? That which we call a rose\n    By any other name would smell as sweet.\n  ")]), _vm._v(" "), _c('n3-button', {
      staticClass: "btn btn-success",
      nativeOn: {
        "click": function($event) {
          _vm.showBigModal($event)
        }
      }
    }, [_vm._v("Big modal")]), _vm._v(" "), _c('n3-modal', {
      ref: "bigModal",
      attrs: {
        "title": "Big Modal",
        "effect": "fade",
        "width": "800px"
      }
    }, [_c('div', {
      slot: "body"
    }, [_vm._v("\n    What's in a name? That which we call a rose\n    By any other name would smell as sweet.\n  ")])]), _vm._v(" "), _c('n3-button', {
      staticClass: "btn btn-primary",
      nativeOn: {
        "click": function($event) {
          _vm.showZoomModal($event)
        }
      }
    }, [_vm._v("Zoom modal")]), _vm._v(" "), _c('n3-modal', {
      ref: "zoomModal",
      attrs: {
        "title": "Zoom Modal",
        "effect": "zoom",
        "width": "400px"
      }
    }, [_c('div', {
      slot: "body"
    }, [_vm._v("\n    What's in a name? That which we call a rose\n    By any other name would smell as sweet.\n  ")])]), _vm._v(" "), _c('n3-button', {
      nativeOn: {
        "click": function($event) {
          _vm.showCustomModal($event)
        }
      }
    }, [_vm._v("Show custom modal")]), _vm._v(" "), _c('n3-modal', {
      ref: "customModal",
      attrs: {
        "effect": "fade",
        "width": "400px"
      }
    }, [_c('div', {
      slot: "header"
    }), _vm._v(" "), _c('div', {
      slot: "body"
    }, [_vm._v("\n    What's in a name? That which we call a rose\n    By any other name would smell as sweet.\n  ")]), _vm._v(" "), _c('div', {
      slot: "footer"
    })]), _vm._v(" "), _c('n3-button', {
      nativeOn: {
        "click": function($event) {
          _vm.showConfirm($event)
        }
      }
    }, [_vm._v("Show confirm")]), _vm._v(" "), _c('n3-button', {
      nativeOn: {
        "click": function($event) {
          _vm.showAlert($event)
        }
      }
    }, [_vm._v("Show alert")])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("函数调用")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("组件调用")]), _vm._v(" "), _c('h4', [_vm._v("组件参数")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h4', [_vm._v("Events")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h4', [_vm._v("组件方法")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("函数调用")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("直接在实例中调用this.n3Mode进行modal的创建和操作")])]), _vm._v(" "), _c('h4', [_vm._v("函数参数")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h3', [_vm._v("用法说明")]), _vm._v(" "), _c('h4', [_vm._v("组件驱动")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', [_vm._v("但是如果你需要自己定制弹出框内容，你可以实现")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h4', [_vm._v("函数驱动")]), _vm._v(" "), _c('p', [_vm._v("N3 提供函数驱动的一次性模态框，通过实例属性 n3Modal.alert 及 n3Modal.confirm 调用，它会在使用时动态绑定到 DOM 树中，并在关闭后自动销毁。")]), _vm._v(" "), _c('p', [_vm._v("为了还原原生对话框操作体验，函数驱动的弹出框将不能通过点击背景进行关闭。")]), _vm._v(" "), _vm._m(9)], 1)]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"showModal\"")]), _vm._v(">")]), _vm._v("Show modal"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-modal")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"Modal title\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("effect")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"fade\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("width")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"400px\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("ref")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"modal\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"body\"")]), _vm._v(">")]), _vm._v("\n    What's in a name? That which we call a rose\n    By any other name would smell as sweet.\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-modal")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"btn btn-success\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"showBigModal\"")]), _vm._v(">")]), _vm._v("Big modal"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-modal")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"Big Modal\"")]), _vm._v("  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("effect")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"fade\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("width")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"800px\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("ref")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"bigModal\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"body\"")]), _vm._v(">")]), _vm._v("\n    What's in a name? That which we call a rose\n    By any other name would smell as sweet.\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-modal")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"btn btn-primary\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"showZoomModal\"")]), _vm._v(">")]), _vm._v("Zoom modal"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-modal")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("title")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"Zoom Modal\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("effect")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"zoom\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("width")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"400px\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("ref")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"zoomModal\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"body\"")]), _vm._v(">")]), _vm._v("\n    What's in a name? That which we call a rose\n    By any other name would smell as sweet.\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-modal")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@click.native")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"showCustomModal\"")]), _vm._v(">")]), _vm._v("Show custom modal"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-button")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-modal")]), _vm._v("  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("effect")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"fade\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("width")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"400px\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("ref")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"customModal\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"header\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"body\"")]), _vm._v(">")]), _vm._v("\n    What's in a name? That which we call a rose\n    By any other name would smell as sweet.\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"footer\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-modal")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-javascript"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n  data () {\n    "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n    }\n  },\n  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("methods")]), _vm._v(": {\n    showModal () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".$refs.modal.open()\n    },\n    showBigModal () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".$refs.bigModal.open()\n    },\n    showZoomModal () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".$refs.zoomModal.open()\n    },\n    showCustomModal () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".$refs.customModal.open()\n    }\n  }\n}\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-javascript"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("methods")]), _vm._v(": {\n    showAlert () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".n3Modal.alert({\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'消息框'")]), _vm._v("\n        message: "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'这是一个消息框。'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("effect")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'fade'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'info'")]), _vm._v(",\n        onShow () {\n          "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'打开对话框时触发'")]), _vm._v(")\n        },\n        onHide () {\n          "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'关闭对话框时触发'")]), _vm._v(")\n        }\n      })\n    },\n    showConfirm () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".n3Modal.confirm({\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("title")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'对话框'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("message")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'这是一个提供选择的对话框。'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("effect")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'zoom'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("type")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'success'")]), _vm._v(",\n        onShow () {\n          "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'打开对话框时触发'")]), _vm._v(")\n        },\n        onConfirm () {\n          "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'点击确定按钮时触发'")]), _vm._v(")\n        },\n        onHide () {\n          "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'关闭对话框时触发'")]), _vm._v(")\n        }\n      })\n    }\n  }\n}\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("弹出框标题")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("effect")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("'fade'")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("fade``zoom")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("600px")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("backdrop")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("true")])]), _vm._v(" "), _c('td', [_vm._v("点击遮罩层是否关闭弹出框")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("show")]), _vm._v(" "), _c('td', [_vm._v("显示模态框时")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("hide")]), _vm._v(" "), _c('td', [_vm._v("隐藏模态框时")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("confirm")]), _vm._v(" "), _c('td', [_vm._v("按下确认时")]), _vm._v(" "), _c('td')])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("方法名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("备注")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("open")]), _vm._v(" "), _c('td', [_vm._v("显示模态框")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("close")]), _vm._v(" "), _c('td', [_vm._v("隐藏模态框")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("confirm")]), _vm._v(" "), _c('td', [_vm._v("触发确认事件")]), _vm._v(" "), _c('td')])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("title")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("弹出框标题，如果为空则不渲染 header")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("message")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("弹出框内容")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("effect")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("'fade'")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("fade``zoom")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("600px")])]), _vm._v(" "), _c('td', [_vm._v("弹出框类型，用于决定弹出框提示图标。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("600px")])]), _vm._v(" "), _c('td', [_vm._v("弹出框宽度")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("onShow")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("打开弹出框时的回调函数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("onHide")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("关闭弹出框时的回调函数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("onConfirm")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("点击弹出框确定按钮时的回调函数")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如果你只需要一个简单的弹出框 ，你只需要传递 "), _c('code', [_vm._v("title")]), _vm._v(" 参数 ，将默认带上footer.")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"header\"")]), _vm._v(">")]), _vm._v("..."), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"body\"")]), _vm._v(">")]), _vm._v("..."), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"footer\"")]), _vm._v(">")]), _vm._v("..."), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-javascript"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("const")]), _vm._v(" options = {...}\n\n"), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("methods")]), _vm._v(": {\n    showAlert () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".n3Modal.alert(options)\n    },\n    showConfirm () {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".n3Modal.confirm(options)\n    }\n  }\n}\n\n")])])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-320b533e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-320b533e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_zh/n3ModalDocs.md
// module id = 879
// module chunks = 0